
import Base from "../../../components/base/Base.vue";
import LayoutService from "@/services/layout.service";
import { ActionTypes } from "@/store/actions";
export default class Main extends Base {
  loading = false;
  created() {
    this.store.dispatch(ActionTypes.GET_LIST_GAMES, undefined);
    LayoutService.getLoading.subscribe(state => {
      this.loading = state;
    })
  }
}
